<template>
    <div class="contain">
        <HeaderMenu></HeaderMenu>
        <div class="main">
            <LoginBox></LoginBox>
        </div>
    </div>
</template>

<script>
import HeaderMenu from '@/components/HeaderMenu.vue';
import LoginBox from '@/components/LoginBox.vue';

export default {
    data() {
        return {

        };
    },
    beforeCreate() {

    },
    mounted() {
    },
    methods: {
    },
    components: { HeaderMenu, LoginBox }
}
</script>

<style scoped>
.main {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    min-height: calc(100vh - 60px);
    justify-content: center;
}
</style>